import Marquee from "react-fast-marquee";

const WORDS = [
  "Universities",
  "Scholarships",
  "SOP · LOR",
  "Visa Success",
  "IELTS · TOEFL",
  "Interviews",
  "Departures",
];

export default function EditorialMarquee() {
  return (
    <section
      aria-label="editorial marquee"
      className="relative py-14 md:py-20 border-y border-[#0a192f]/10 bg-[#FDFDFD] overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee gradient={false} speed={38} pauseOnHover={false}>
        <div className="marquee-track pr-16">
          {WORDS.concat(WORDS).map((w, i) => (
            <span key={i} className="inline-flex items-center gap-16">
              <span
                className={`font-display font-medium leading-none text-[16vw] md:text-[13vw] ${
                  i % 2 === 0 ? "text-stroke" : "text-[#0a192f]"
                }`}
              >
                {w}
              </span>
              <span className="text-[#00A3FF] text-6xl md:text-8xl leading-none">
                ✷
              </span>
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
